import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import Home from '../views/Home/Index.vue'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/vips',
    name: 'Vips',
    meta: {
      title: "VIP会员",
      tga: true, // 是否上报
    },
    // component: () => import(/* webpackChunkName: "activityThank" */ '../views/Activity/Vips/Index.vue')
    // component: () => import(/* webpackChunkName: "vips" */ '../views/Vips/Index.vue')
    component: () => import(/* webpackChunkName: "activityThank" */ '../views/Activity/Vips/Transfer.vue')
  },
  {
    path: '/vipsOld',
    name: 'VipsOld',
    meta: {
      title: "VIP会员",
      tga: true, // 是否上报
    },
    component: () => import(/* webpackChunkName: "vipsOld" */ '../views/VipsOld/Index.vue')
  },
  {
    path: '/vipsRights',
    name: 'VipsRights',
    meta: {
      title: "VIP会员购买",
      tga: true, // 是否上报
    },
    component: () => import(/* webpackChunkName: "VipsRights" */ '../views/VipsRights/Index.vue')
  },
  {
    path: '/vipsRights/Ai',
    name: 'VipsRightsAi',
    meta: {
      title: "VIP会员购买",
      tga: true, // 是否上报
    },
    component: () => import(/* webpackChunkName: "VipsRights" */ '../views/VipsRights/VipModal/Ai.vue')
  },
  {
    path: '/vipsRights/ai_v2',
    name: 'VipsRightsAiV2',
    meta: {
      title: "VIP会员购买",
      tga: true, // 是否上报
    },
    component: () => import(/* webpackChunkName: "VipsRights" */ '../views/VipsRights/VipModal/AiV2.vue')
  },
  {
    path: '/analysis',
    name: 'Analysis',
    meta: {
      title: "答案解析",
      tga: true, // 是否上报
    },
    component: () => import(/* webpackChunkName: "Analysis" */ '../views/Analysis/Index.vue')
  },
  {
    path: '/analysis_pop',
    name: 'AnalysisPop',
    meta: {
      title: "答案解析",
      tga: true, // 是否上报
    },
    component: () => import(/* webpackChunkName: "Analysis" */ '../views/AnalysisPop/Index.vue')
  },
  {
    path: '/analysis_content',
    name: 'AnalysisContent',
    meta: {
      title: "答案解析",
    },
    component: () => import(/* webpackChunkName: "Analysis" */ '../views/Analysis/Content.vue')
  },
  {
    path: '/note_answer_content',
    name: 'NoteAnswerContent',
    meta: {
      title: "注释答案",
    },
    component: () => import(/* webpackChunkName: "NoteAnswer" */ '../views/NoteAnswer/Content.vue')
  },
  {
    path: '/note_answer',
    name: 'NoteAnswer',
    meta: {
      title: "注释答案",
      // tga: true, // 是否上报
    },
    component: () => import(/* webpackChunkName: "NoteAnswer" */ '../views/NoteAnswer/Index.vue')
  },
  {
    // _app_template=fullscreen_notitle&_app_fullscreen=true&statusBarHeight=0 (app 中会加入statusBarHeight参数)
    path: '/booksThemeList',
    name: 'booksThemeList',
    meta: {
      title: "书籍主题",
      tga: true, // 是否上报
    },
    component: () => import(/* webpackChunkName: "booksThemeList" */ '../views/BooksThemeList/Index.vue')
  },
  {
    path: '/booksDetail/:id',
    name: 'booksDetail',
    meta: {
      title: "书籍详情",
      tga: true, // 是否上报
    },
    component: () => import(/* webpackChunkName: "booksDetail" */ '../views/BooksDetail/Index/Index.vue')
  },
  {
    path: '/materials/share/:id',
    name: 'materialsShare',
    meta: {
      title: "学习资料",
      tga: true, // 是否上报
    },
    component: () => import(/* webpackChunkName: "materialsShare" */ '../views/Materials/Share/Index.vue')
  },
  {
    path: '/materials/list',
    name: 'materialsList',
    meta: {
      title: "学习资料",
      tga: true, // 是否上报
    },
    component: () => import(/* webpackChunkName: "materialsShare" */ '../views/Materials/List/Index.vue')
  },
  {
    path: '/booksDetailPop/:id',
    name: 'booksDetailPop',
    meta: {
      title: "买书赠数字服务"
    },
    component: () => import(/* webpackChunkName: "booksDetailPop" */ '../views/BooksDetail/Pop/Index.vue')
  },
  {
    path: '/my_medal',
    name: 'myMedal',
    meta: {
      title: "我的勋章",
      tga: true, // 是否上报
    },
    component: () => import(/* webpackChunkName: "myMedal" */ '../views/MyMedal/Index.vue')
  },
  {
    path: '/my_medal_detail',
    name: 'myMedalDetail',
    meta: {
      title: "我的勋章",
      tga: true, // 是否上报
    },
    component: () => import(/* webpackChunkName: "myMedalDetail" */ '../views/MyMedal/Detail/Index.vue')
  },
  {
    path: '/my_medal_share',
    name: 'myMedalShare',
    meta: {
      title: "我的勋章"
    },
    component: () => import(/* webpackChunkName: "myMedalShare" */ '../views/MyMedal/Share.vue')
  },
  {
    path: '/medal_share_camp',
    name: 'medalShareCamp',
    meta: {
      title: "我的勋章"
    },
    component: () => import(/* webpackChunkName: "medalShareCamp" */ '../views/MyMedal/ShareCamp.vue')
  },
  {
    path: '/medal_share_certificate',
    name: 'medalShareCertificate',
    meta: {
      title: "证书分享"
    },
    component: () => import(/* webpackChunkName: "medalShareCamp" */ '../views/MyMedal/ShareCertificate.vue')
  },
  {
    path: '/medal',
    name: 'medal',
    meta: {
      title: "我的勋章",
      tga: true, // 是否上报
    },
    component: () => import(/* webpackChunkName: "medal" */ '../views/Medal/Index.vue')
  },
  {
    path: '/medal_clock',
    name: 'medalClock',
    meta: {
      title: "打卡营勋章证书",
      tga: true, // 是否上报
    },
    component: () => import(/* webpackChunkName: "myMedal" */ '../views/MedalClock/Index.vue')
  },
  {
    path: '/medal_clock_more',
    name: 'medalClockMore',
    meta: {
      title: "打卡营勋章证书",
      tga: true, // 是否上报
    },
    component: () => import(/* webpackChunkName: "medalClockMore" */ '../views/MedalClock/MedalMore.vue')
  },
  {
    path: '/ticket',
    name: 'ticket',
    meta: {
      title: ""
    },
    component: () => import(/* webpackChunkName: "ticket" */ '../views/Ticket/Index.vue')
  },
  {
    path: '/ticket_index',
    name: 'ticketIndex',
    meta: {
      title: ""
    },
    component: () => import(/* webpackChunkName: "ticketIndex" */ '../views/TicketIndex/Index.vue')
  },
  {
    path: '/ticket_index_upgrade',
    name: 'ticketIndexUpgrade',
    meta: {
      title: ""
    },
    component: () => import(/* webpackChunkName: "ticketIndexUpgrade" */ '../views/TicketIndex/Upgrade.vue')
  },
  {
    path: '/listen_medal',
    name: 'listenMedal',
    meta: {
      title: "听书勋章"
    },
    component: () => import(/* webpackChunkName: "ListenMedal" */ '../views/ListenMedal/Index.vue')
  },
  {
    path: '/listen_medal_share',
    name: 'listenMedalShare',
    meta: {
      title: "听书勋章"
    },
    component: () => import(/* webpackChunkName: "listenMedalShare" */ '../views/ListenMedalShare/Index.vue')
  },
  {
    path: '/vip_convert/success',
    name: 'vipConvertSuccess',
    meta: {
      title: "会员兑换"
    },
    component: () => import(/* webpackChunkName: "VipConvert" */ '../views/VipConvert/Success/Index.vue')
  },
  {
    path: '/book_share/:id',
    name: 'bookShare',
    meta: {
      title: "沪学习"
    },
    component: () => import(/* webpackChunkName: "bookShare" */ '../views/BookShare/Index.vue')
  },
  {
    path: '/outside_book_share/:id',
    name: 'outsideBookShare',
    meta: {
      title: "沪学习"
    },
    component: () => import(/* webpackChunkName: "outsideBookShare" */ '../views/OutsideBookShare/Index.vue')
  },
  {
    path: '/contract/vipaudo',
    name: 'contractVipOpen',
    meta: {
      title: "自动续费服务协议"
    },
    component: () => import(/* webpackChunkName: "contractVipOpen" */ '../views/Contract/VipAudoOpenContract.vue')
  },
  {
    path: '/contract/vipuser',
    name: 'contractVipUser',
    meta: {
      title: "会员协议"
    },
    component: () => import(/* webpackChunkName: "contractVipUser" */ '../views/Contract/VipUserContract.vue')
  },
  {
    path: '/contract/auto_renew',
    name: 'contractAutoRenew',
    meta: {
      title: "自动续费协议"
    },
    component: () => import(/* webpackChunkName: "contractAutoRenew" */ '../views/Contract/AutoRenewContract.vue')
  },
  {
    path: '/contract/user',
    name: 'contractUser',
    meta: {
      title: "沪学习用户协议"
    },
    component: () => import(/* webpackChunkName: "contractUser" */ '../views/Contract/userContract.vue')
  },
  {
    path: '/contract/privacy',
    name: 'contractPrivacy',
    meta: {
      title: "沪学习隐私政策"
    },
    component: () => import(/* webpackChunkName: "contractPrivacy" */ '../views/Contract/PrivacyContract.vue')
  },
  {
    path: '/contract/privacy_ylfz_sdk',
    name: 'contractPrivacy',
    meta: {
      title: "易如反掌SDK隐私政策"
    },
    component: () => import(/* webpackChunkName: "contractPrivacy" */ '../views/Contract/PrivacyYlfzSdkContract.vue')
  },
  {
    path: '/contract/privacy_short',
    name: 'contractPrivacyShort',
    meta: {
      title: "沪学习隐私政策概要"
    },
    component: () => import(/* webpackChunkName: "contractPrivacyShort" */ '../views/Contract/PrivacyShortContract.vue')
  },
  {
    path: '/contract/teacher_contract',
    name: 'contractTeacher',
    meta: {
      title: "沪学习教师隐私政策"
    },
    component: () => import(/* webpackChunkName: "contractTeacher" */ '../views/Contract/TeacherContract.vue')
  },
  {
    path: '/contract/inventory',
    name: 'contractInventory',
    meta: {
      title: "【沪学习】已收集个人信息清单"
    },
    component: () => import(/* webpackChunkName: "contractInventory" */ '../views/Contract/InventoryContract.vue')
  },
  {
    path: '/contract/other_inventory',
    name: 'contractOtherInventory',
    meta: {
      title: "【沪学习】第三方信息共享清单"
    },
    component: () => import(/* webpackChunkName: "otherContractInventory" */ '../views/Contract/OtherInventoryContract.vue')
  },
  {
    path: '/contract/juveniles',
    name: 'contractJuveniles',
    meta: {
      title: "沪学习未成年人个人信息保护规则及监护人须知"
    },
    component: () => import(/* webpackChunkName: "contractPrivacy" */ '../views/Contract/JuvenilesContract.vue')
  },
  {
    path: '/contract/ai_disclaimer',
    name: 'contractAiDisclaimer',
    meta: {
      title: "AI应用免责声明"
    },
    component: () => import(/* webpackChunkName: "contractAIDisclaimer" */ '../views/Contract/AIDisclaimer.vue')
  },
  {
    path: '/contract/account_deletion',
    name: 'contractAccountDeletion',
    meta: {
      title: "注销账号"
    },
    component: () => import(/* webpackChunkName: "contractPrivacy" */ '../views/Contract/AccountDeletion.vue')
  },
  {
    path: '/licence',
    name: 'licence',
    meta: {
      title: "企业资质"
    },
    component: () => import(/* webpackChunkName: "licence" */ '../views/Licence/Index.vue')
  },
  {
    path: '/namibox_download',
    name: 'namiboxDownload',
    meta: {
      title: "纳米盒全国版下载",
      tga: true, // 是否上报
      downloadHeader: false
    },
    component: () => import(/* webpackChunkName: "namiboxDownload" */ '../views/DownNamibox/Index.vue')
  },
  {
    path: '/auth',
    name: 'Auth',
    meta: {
      title: "联合登陆"
    },
    component: () => import(/* webpackChunkName: "Auth" */ '../views/Auth/Index.vue')
  },
  {
    path: '/change_info',
    name: 'ChangeInfo',
    meta: {
      title: "登陆"
    },
    component: () => import(/* webpackChunkName: "ChangeInfo" */ '../views/ChangeInfo/Index.vue')
  },
  {
    path: '/pop/new_user',
    name: 'PopNewUser',
    meta: {
      title: "弹框"
    },
    component: () => import(/* webpackChunkName: "PopNewUser" */ '../views/NewUserPop/NewUser.vue')
  },
  {
    path: '/wxservice',
    name: 'wxservice',
    meta: {
      title: ""
    },
    component: () => import(/* webpackChunkName: "wxservice" */ '../views/WxService/Index.vue')
  },
  {
    path: '/camp_wx_service',
    name: 'camp_wx_service',
    meta: {
      title: ""
    },
    component: () => import(/* webpackChunkName: "CampWxService" */ '../views/CampWxService/Index.vue')
  },
  {
    path: '/listen_report',
    name: 'listenReport',
    meta: {
      title: "阅读周报"
    },
    component: () => import(/* webpackChunkName: "listenReport" */ '../views/ListenReport/Index.vue')
  },
  {
    path: '/listen_report_share',
    name: 'listenReportShare',
    meta: {
      title: "阅读周报"
    },
    component: () => import(/* webpackChunkName: "listenReportShare" */ '../views/ListenReportShare/Index.vue')
  },
  {
    path: '/study_report',
    name: 'studyReport',
    meta: {
      title: "学习报告",
      tga: true, // 是否上报
    },
    component: () => import(/* webpackChunkName: "studyReport" */ '../views/StudyReport/Index.vue')
  },
  {
    path: '/study_report_share',
    name: 'studyReportShare',
    meta: {
      title: "学习报告"
    },
    component: () => import(/* webpackChunkName: "studyReportShare" */ '../views/StudyReportShare/Index.vue')
  },
  {
    path: '/study_camp_report',
    name: 'studyCampReport',
    meta: {
      title: "学习报告"
    },
    component: () => import(/* webpackChunkName: "studyCampReport" */ '../views/StudyCampReport/Index.vue')
  },
  {
    path: '/study_camp_share_report',
    name: 'studyCampShareReport',
    meta: {
      title: "学习报告"
    },
    component: () => import(/* webpackChunkName: "studyCampReport" */ '../views/StudyCampReport/ShareReport.vue')
  },
  // 纠音学习报告
  {
    path: '/pronunciation_report',
    name: 'pronunciationReport',
    meta: {
      title: "学习报告"
    },
    component: () => import(/* webpackChunkName: "pronunciationReport" */ '../views/StudyReport/PronunciationReport.vue')
  },
  {
    path: '/app_upgrade',
    name: 'newVersion',
    meta: {
      title: ""
    },
    component: () => import(/* webpackChunkName: "newVersion" */ '../views/NewVersion/Index.vue')
  },
  {
    path: '/activity/double_eleven',
    name: 'activityDoubleEleven',
    meta: {
      title: "VIP超级会员买1得4",
      tga: true, // 是否上报
    },
    component: () => import(/* webpackChunkName: "activityDoubleEleven" */ '../views/Activity/doubleEleven/Index.vue')
  },
  {
    path: '/activity/vips',
    name: 'activityVips',
    meta: {
      title: "沪学习会员",
      tga: true, // 是否上报
    },
    // component: () => import(/* webpackChunkName: "activityThank" */ '../views/Activity/Vips/Index.vue')
    component: () => import(/* webpackChunkName: "activityThank" */ '../views/Activity/Vips/Transfer.vue')
  },

  {
    path: '/activity/member_product',
    name: 'activityMemberProduct',
    meta: {
      title: "会员活动",
    },
    component: () => import(/* webpackChunkName: "activityMemberProduct" */ '../views/Activity/MemberProduct/Index.vue')
  },
  {
    path: '/activity/thank',
    name: 'activityThank',
    meta: {
      title: "VIP超级会员买1得5",
      tga: true, // 是否上报
    },
    component: () => import(/* webpackChunkName: "activityThank" */ '../views/Activity/review/Index.vue')
  },
  // 跳转加微
  {
    path: '/jump_serve',
    name: 'jumpServe',
    meta: {
      title: "客服中心"
    },
    component: () => import(/* webpackChunkName: "jumpServe" */ '../views/JumpServe/Index.vue')
  },
  {
    path: '/annual_report',
    name: 'annualReport',
    meta: {
      title: "年度报告"
    },
    component: () => import(/* webpackChunkName: "annualReport" */ '../views/AnnualReport/Index.vue')
  },
  {
    path: '/annual_report_share',
    name: 'annualReportShare',
    meta: {
      title: "年度报告"
    },
    component: () => import(/* webpackChunkName: "annualReport" */ '../views/AnnualReport/Share.vue')
  },
  {
    path: '/renew_manage',
    name: 'renewManage',
    meta: {
      title: "续费管理",
      tga: true, // 是否上报
    },
    component: () => import(/* webpackChunkName: "renewManage" */ '../views/Buy/RenewManage/Index.vue')
  },
  {
    path: '/learn/report',
    name: 'learnReport',
    meta: {
      title: "学习报告"
    },
    component: () => import(/* webpackChunkName: "learnReport" */ '../views/StudyReport/Report.vue')
  },
  {
    path: '/learn/report_share',
    name: 'reportShare',
    meta: {
      title: "学习报告分享"
    },
    component: () => import(/* webpackChunkName: "reportShare" */ '../views/StudyClockInShare/ReportShare.vue')
  },
  {
    path: '/buy_product',
    name: 'buyProduct',
    meta: {
      title: "确认订单",
      tga: true, // 是否上报
    },
    component: () => import(/* webpackChunkName: "buyProduct" */ '../views/Buy/Index/Index.vue')
  },
  {
    path: '/buy_express_detail/:id',
    name: 'buyExpressDetail',
    meta: {
      title: "物流详情",
      tga: true, // 是否上报
    },
    component: () => import(/* webpackChunkName: "buyExpressDetail" */ '../views/Buy/ExpressDetail/Index.vue')
  },
  {
    path: '/buy_parent_pay',
    name: 'buyParentPay',
    meta: {
      title: "家长代付",
      // tga: true, // 是否上报
    },
    component: () => import(/* webpackChunkName: "buyParentPay" */ '../views/Buy/ParentPay.vue')
  },
  {
    path: '/buy_success',
    name: 'buySuccess',
    meta: {
      title: "支付成功",
      tga: true, // 是否上报
    },
    component: () => import(/* webpackChunkName: "buyProductSuccess" */ '../views/Buy/Success/Index.vue')
  },
  {
    path: '/buy_fail',
    name: 'buyFail',
    meta: {
      title: "支付失败"
    },
    component: () => import(/* webpackChunkName: "buyProductFail" */ '../views/Buy/Fail.vue')
  },
  {
    path: '/buy_order_detail',
    name: 'buyOrderDetail',
    meta: {
      title: "交易完成"
    },
    component: () => import(/* webpackChunkName: "buyOrderDetail" */ '../views/Buy/OrderDetail.vue')
  },
  {
    path: '/weixinAuthor',
    name: 'weixinAuthor',
    meta: {
      title: "微信授权"
    },
    component: () => import(/* webpackChunkName: "weixinAuthor" */ '../views/WeixinAuthor/Index.vue')
  },
  {
    path: '/weixinAuthor/Bind',
    name: 'weixinAuthorBind',
    meta: {
      title: "微信授权绑定"
    },
    component: () => import(/* webpackChunkName: "weixinAuthor" */ '../views/WeixinAuthor/Bind.vue')
  },
  {
    path: '/check_answer',
    name: 'checkAnswer',
    meta: {
      title: "查看答案"
    },
    component: () => import(/* webpackChunkName: "checkAnswer" */ '../views/CheckAnswer/Index.vue')
  },
  {
    path: '/english_book_list',
    name: 'englishBookList',
    meta: {
      title: "购买课本"
    },
    component: () => import(/* webpackChunkName: "englishBookList" */ '../views/EnglishBookList/Index.vue')
  },
  {
    path: '/tools',
    name: 'Tools',
    meta: {
      title: "学习工具",
      tga: true, // 是否上报
    },
    component: () => import(/* webpackChunkName: "tools" */ '../views/Tools/Index.vue')
  },
  {
    path: '/equity_exchange',
    name: 'equityExchange',
    meta: {
      title: "兑换",
    },
    component: () => import(/* webpackChunkName: "equityExchange" */ '../views/EquityExchange/Index.vue')
  },
  {
    path: '/study_community',
    name: 'StudyCommunity',
    meta: {
      title: "学习社区",
      tga: true, // 是否上报
    },
    component: () => import(/* webpackChunkName: "studyCommunity" */ '../views/StudyCommunity/Index.vue')
  },
  // 学习打卡详情
  {
    path: '/study_clock_in_detail',
    name: 'StudyClockInDetail',
    meta: {
      title: "打卡详情",
      tga: true, // 是否上报
    },
    component: () => import(/* webpackChunkName: "studyClockInDetail" */ '../views/StudyClockInDetail/Index.vue')
  },
  // 学习话题详情
  {
    path: '/study_topic',
    name: 'StudyTopic',
    meta: {
      title: "",
      tga: true, // 是否上报
    },
    component: () => import(/* webpackChunkName: "studyTopic" */ '../views/StudyTopic/Index.vue')
  },
  {
    path: '/study_clock_in_share',
    name: 'StudyClockInShare',
    meta: {
      title: '分享海报',
      tga: true, // 是否上报
    },
    component: () => import(/* webpackChunkName: "studyClockInShare" */ '../views/StudyClockInShare/Index.vue')
  },
  // 学习打卡视频播放
  {
    path: '/study_clock/video',
    name: 'StudyClockVideo',
    meta: {
      title: "视频播放",
      tga: true, // 是否上报
    },
    component: () => import(/* webpackChunkName: "StudyClockVideo" */ '../views/StudyClockInDetail/PlayVideo.vue')
  },
  {
    path: '/study_clock_in',
    name: 'StudyClockIn',
    meta: {
      title: "打卡记录",
      tga: true, // 是否上报
    },
    component: () => import(/* webpackChunkName: "studyClockIn" */ '../views/StudyClockIn/Index.vue')
  },
  {
    path: '/effect_punch',
    name: 'effectPunch',
    meta: {
      title: "动画打卡",
      tga: true, // 是否上报
    },
    component: () => import(/* webpackChunkName: "effectPunch" */ '../views/EffectPunch/Index.vue')
  },
  {
    path: '/effect_punch/edit',
    name: 'effectPunchEdit',
    meta: {
      title: "视频配乐",
      tga: true, // 是否上报
    },
    component: () => import(/* webpackChunkName: "effectPunchEditor" */ '../views/EffectPunch/Edit/Index.vue')
  },
  {
    path: '/effect_punch/add',
    name: 'effectPunchAdd',
    meta: {
      title: "",
      tga: true, // 是否上报
    },
    component: () => import(/* webpackChunkName: "effectPunchEditor" */ '../views/EffectPunch/Add/Index.vue')
  },
  {
    path: '/effect_punch/share',
    name: 'effectPunchShare',
    meta: {
      title: "",
    },
    component: () => import(/* webpackChunkName: "effectPunchShare" */ '../views/EffectPunch/Share/Index.vue')
  },
  {
    path: '/redeem',
    name: 'redeem',
    meta: {
      title: "兑换",
    },
    component: () => import(/* webpackChunkName: "redeem" */ '../views/Redeem/Index.vue')
  },
  {
    path: '/redeem_product',
    name: 'redeemProduct',
    meta: {
      title: "兑换产品",
    },
    component: () => import(/* webpackChunkName: "redeemProduct" */ '../views/Redeem/Product/Index.vue')
  },
  {
    path: '/redeem_vip',
    name: 'redeemVip',
    meta: {
      title: "会员兑换",
    },
    component: () => import(/* webpackChunkName: "redeemVip" */ '../views/Redeem/Vip/Index.vue')
  },
  {
    path: '/redeem_combine',
    name: 'redeemCombine',
    meta: {
      title: "兑换产品",
    },
    component: () => import(/* webpackChunkName: "redeemCamp" */ '../views/Redeem/Combine/Index.vue')
  },
  {
    path: '/redeem_success',
    name: 'redeemSuccess',
    meta: {
      title: "兑换成功",
    },
    component: () => import(/* webpackChunkName: "redeemSuccess" */ '../views/Redeem/success.vue')
  },
  {
    path: '/redeem_list',
    name: 'redeemList',
    meta: {
      title: "我的兑换",
    },
    component: () => import(/* webpackChunkName: "redeemList" */ '../views/Redeem/RedeemList/Index.vue')
  },
  {
    path: '/open_vip',
    name: 'OpenVip',
    meta: {
      title: "沪学习"
    },
    component: () => import(/* webpackChunkName: "OpenVip" */ '../views/OpenVip/Index.vue')
  },
  {
    path: '/short_video/:id',
    name: 'ShortVideo',
    meta: {
      title: "沪学习"
    },
    component: () => import(/* webpackChunkName: "ShortVideo" */ '../views/ShortVideo/Index.vue')
  },
  {
    path: '/video_punch_detail/:id',
    name: 'videoPunchDetail',
    meta: {
      title: "沪学习"
    },
    component: () => import(/* webpackChunkName: "ShortVideo" */ '../views/VideoPunch/Detail.vue')
  },
  {
    path: '/energy_list',
    name: 'EnergyList',
    meta: {
      title: "能量值"
    },
    component: () => import(/* webpackChunkName: "EnergyList" */ '../views/EnergyList/Index.vue')
  },
  {
    path: '/soft_article',
    name: 'SoftArticle',
    meta: {
      title: "",
      tga: true, // 是否上报
    },
    component: () => import(/* webpackChunkName: "SoftArticle" */ '../views/SoftArticle/Index.vue')
  },
  {
    path: '/soft_article/lottery_success',
    name: 'SoftArticleLotterySuccess',
    meta: {
      title: "",
      tga: true, // 是否上报
    },
    component: () => import(/* webpackChunkName: "SoftArticleLotterySuccess" */ '../views/SoftArticle/Success.vue')
  },
  {
    path: '/notes',
    name: 'notes',
    meta: {
      title: "我的笔记",
      tga: true, // 是否上报
    },
    component: () => import(/* webpackChunkName: "notes" */ '../views/Notes/index.vue')
  },
  {
    path: '/study_camp/detail',
    name: 'studyCampDetail',
    meta: {
      title: "",
      tga: true, // 是否上报
    },
    component: () => import(/* webpackChunkName: "studyCampDetail" */ '../views/StudyCampDetail/Index.vue')
  },
  {
    path: '/study_camp/reward',
    name: 'studyCampReward',
    meta: {
      title: "领取奖励",
      tga: true, // 是否上报
    },
    component: () => import(/* webpackChunkName: "studyCampReward" */ '../views/StudyCampReward/Index.vue')
  },
  {
    path: '/study_camp/reward_success',
    name: 'studyCampRewardSuccess',
    meta: {
      title: "领取奖励",
      tga: true, // 是否上报
    },
    component: () => import(/* webpackChunkName: "studyCampReward" */ '../views/StudyCampReward/Success.vue')
  },
  {
    path: '/address/index',
    name: 'addressIndex',
    meta: {
      title: "地址管理",
      tga: true, // 是否上报
    },
    component: () => import(/* webpackChunkName: "addressList" */ '../views/Address/Index.vue')
  },
  {
    path: '/address/detail',
    name: 'addressDetail',
    meta: {
      title: "地址管理",
      tga: true, // 是否上报
    },
    component: () => import(/* webpackChunkName: "addressDetail" */ '../views/Address/Detail.vue')
  },
  {
    path: '/wx/official/account',
    name: 'wxOfficialAccount',
    meta: {
      title: "沪学习",
      tga: true, // 是否上报
    },
    component: () => import(/* webpackChunkName: "wxOfficialAccount" */ '../views/WxOfficialAccount/Index.vue')
  },
  {
    path: '/suspense_page',
    name: 'suspensePage',
    meta: {
      title: "沪学习",
      tga: true, // 是否上报
    },
    component: () => import(/* webpackChunkName: "suspensePage" */ '../views/SuspensePage/Index.vue')
  },
  {
    path: '/my_medals_coming',
    name: 'myMedalsComing',
    meta: {
      title: "我的勋章", // 新的勋章体系
      tga: true, // 是否上报
    },
    component: () => import(/* webpackChunkName: "myMedalComing" */ '../views/MyMedalComing/Index.vue')
  },
  {
    path: '/read_rank',
    name: 'readRank',
    meta: {
      title: "阅读排行榜",
      tga: false, // 是否上报
    },
    component: () => import(/* webpackChunkName: "readRank" */ '../views/ReadRank/Index.vue')
  },
  {
    path: '/feedback_pop',
    name: 'feedbackPop',
    meta: {
      title: "提示",
    },
    component: () => import(/* webpackChunkName: "feedbackPop" */ '../views/FeedbackPop/Index.vue')
  },
  {
    path: '/pronunciation/index',
    name: 'pronunciationIndex',
    meta: {
      title: '',
      tga: true, // 是否上报
    },
    component: () => import(/* webpackChunkName: "pronunciationIndex" */ '../views/Pronunciation/Index.vue')
  },
  {
    path: '/study_guide/index',
    name: 'studyGuide',
    meta: {
      title: '',
      tga: true, // 是否上报
    },
    component: () => import(/* webpackChunkName: "studyGuide" */ '../views/StudyGuide/Index.vue')
  },
  {
    path: '/cn_character',
    name: 'cnCharacter',
    meta: {
      title: '',
    },
    component: () => import(/* webpackChunkName: "cnCharacter" */ '../views/CnCharacter/Index.vue')
  },
  {
    path: '/ibook/:id',
    name: 'ibook',
    meta: {
      title: '',
      tga: true, // 是否上报
    },
    component: () => import(/* webpackChunkName: "ibook" */ '../views/Ibook/Index.vue')
  },
  {
    path: '/quiz',
    name: 'quiz',
    meta: {
      title: '在线答题',
    },
    component: () => import(/* webpackChunkName: "quiz" */ '../views/Quiz/Index.vue')
  },
  {
    path: '/quiz/report',
    name: 'quizReport',
    meta: {
      title: '答题报告',
    },
    component: () => import(/* webpackChunkName: "quiz" */ '../views/Quiz/QuestionReport.vue')
  },
  {
    path: '/quiz/wrong',
    name: 'quizWrong',
    meta: {
      title: '',
    },
    component: () => import(/* webpackChunkName: "quizWrong" */ '../views/Quiz/Wrong.vue')
  },
  {
    path: '/upgrade/strategy',
    name: 'upgradeStrategy',
    meta: {
      title: '升级攻略',
    },
    component: () => import(/* webpackChunkName: "upgradeStrategy" */ '../views/UpgradeStrategy/Index.vue')
  },
  {
    path: '/ai/study/rank',
    name: 'aiStudyRank',
    meta: {
      title: '打卡榜单',
    },
    component: () => import(/* webpackChunkName: "aiStudyRank" */ '../views/AiStudy/ClockRank.vue')
  },
  {
    path: '/ai/report/list',
    name: 'aiReportList',
    meta: {
      title: '学习报告',
    },
    component: () => import(/* webpackChunkName: "aiReportList" */ '../views/AiStudy/AiReportList.vue')
  },
  {
    path: '/ai/report',
    name: 'aiReport',
    meta: {
      title: '学习报告',
    },
    component: () => import(/* webpackChunkName: "aiReport" */ '../views/AiStudy/AiReport.vue')
  },
  {
    path: '/ai/report/share',
    name: 'aiReportShare',
    meta: {
      title: '学习报告',
    },
    component: () => import(/* webpackChunkName: "aiReportShare" */ '../views/AiStudy/AiReportShare.vue')
  },
  {
    path: '/teacher/certified',
    name: 'teacherCertified',
    meta: {
      title: '教师专区',
    },
    component: () => import(/* webpackChunkName: "teacherCertified" */ '../views/TeacherCertified/Index.vue')
  },
  {
    path: '/teacher/certified/form',
    name: 'teacherCertifiedForm',
    meta: {
      title: '教师认证',
    },
    component: () => import(/* webpackChunkName: "teacherCertifiedForm" */ '../views/TeacherCertified/TeacherForm.vue')
  },
  {
    path: '/teacher/school/list',
    name: 'schoolList',
    meta: {
      title: '任职学校',
    },
    component: () => import(/* webpackChunkName: "schoolList" */ '../views/TeacherCertified/SchoolPop.vue')
  },
  {
    path: '/teacher/audit_result',
    name: 'teacherAuditResult',
    meta: {
      title: '教师认证',
    },
    component: () => import(/* webpackChunkName: "teacherAuditResult" */ '../views/TeacherCertified/AuditResult.vue')
  },
  {
    path: '/week_practice',
    name: 'weekPractice',
    meta: {
      title: "同步周周练",
      tga: true, // 是否上报
    },
    component: () => import(/* webpackChunkName: "weekPractice" */ '../views/WeekPractice/Index.vue')
  },
  {
    path: '/new_vocabulary',
    name: 'newVocabulary',
    meta: {
      title: '听写本',
    },
    component: () => import(/* webpackChunkName: "newVocabulary" */ '../views/NewVocabulary/Index.vue')
  },
  {
    path: '/new_vocabulary/list',
    name: 'newVocabularyList',
    meta: {
      title: '听写本',
    },
    component: () => import(/* webpackChunkName: "newVocabularyList" */ '../views/NewVocabulary/List.vue')
  },
  {
    path: '/new_vocabulary/dictation',
    name: 'newVocabularyDictation',
    meta: {
      title: '听写本',
    },
    component: () => import(/* webpackChunkName: "newVocabularyDictation" */ '../views/NewVocabulary/Dictation.vue')
  },
  {
    path: '/new_vocabulary/wrong_book',
    name: 'newVocabularyWrongBook',
    meta: {
      title: '',
    },
    component: () => import(/* webpackChunkName: "newVocabularyWrongBook" */ '../views/NewVocabulary/WrongBook.vue')
  },
  {
    path: '/demo',
    name: 'demo',
    meta: {
      title: "demo"
    },
    component: () => import(/* webpackChunkName: "demo" */ '../views/Demo/Index.vue')
  },
  {
    path: '/login',
    name: 'login',
    meta: {
      title: "登录",
      tga: false, // 是否上报
    },
    component: () => import(/* webpackChunkName: "login" */ '../views/Login/Index.vue')
  },
  {
    path: '/app_login',
    name: 'AppLogin',
    meta: {
      title: "登录",
      tga: false, // 是否上报
    },
    component: () => import(/* webpackChunkName: "AppLogin" */ '../views/Login/AppLogin.vue')
  },
  {
    path: '/user/center',
    name: 'userCenter',
    meta: {
      title: "用户中心",
      tga: false, // 是否上报
    },
    component: () => import(/* webpackChunkName: "user" */ '../views/User/Index.vue')
  },
  {
    path: '/user/edit',
    name: 'userEdit',
    meta: {
      title: "编辑",
      tga: false, // 是否上报
    },
    component: () => import(/* webpackChunkName: "user" */ '../views/User/Edit.vue')
  },
  {
    path: '/report_pop',
    name: 'reportPop',
    meta: {
      title: "",
      tga: true, // 是否上报
    },
    component: () => import(/* webpackChunkName: "reportPop" */ '../views/ReportPop/Index.vue')
  },
  {
    path: '/report_pop_v2',
    name: 'newReportPop',
    meta: {
      title: "",
      tga: true, // 是否上报
    },
    component: () => import(/* webpackChunkName: "newReportPop" */ '../views/NewReportPop/Index.vue')
  },
  {
    path: '/cosplay_report',
    name: 'cosplayReport',
    meta: {
      title: "",
      tga: true, // 是否上报
    },
    component: () => import(/* webpackChunkName: "cosplayReport" */ '../views/CosplayReport/Index.vue')
  },
  {
    path: '/user/edit_phone',
    name: 'userEditPhone',
    meta: {
      title: "更换手机号",
      tga: false, // 是否上报
    },
    component: () => import(/* webpackChunkName: "user" */ '../views/User/EditPhone/Index.vue')
  },
  {
    path: '*',
    name: 'notFound',
    meta: {
      title: "页面未找到"
    },
    component: () => import(/* webpackChunkName: "notFound" */ '../views/NotFound/Index.vue')
  }
]

const route = new VueRouter({
  mode: 'history',
  // base: process.env.BASE_URL,
  base: '/',
  routes
})

export default route
